import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EntiteService } from '@features/referentiel/services/entite.service';
import { catchError, concatMap, map, mergeMap, of, withLatestFrom } from 'rxjs';
import { AuthActions, authFeature } from '@auth/store';
import { selectTotalEntites } from '@features/referentiel/features';
import { EntiteActions } from '@features/referentiel/actions/entite.actions';


@Injectable()
export class EntiteEffects {

  loadListEntites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.userProfileLoaded),
      concatMap((action) =>
        of(action).pipe(
          withLatestFrom(
            this.store$.select(authFeature.selectUserSiret),
            this.store$.select(selectTotalEntites),
          ),
        ),
      ),
      mergeMap(([, siret, isEntitiesLoaded]) => {
        if (isEntitiesLoaded > 0) {
          return of(EntiteActions.noAction());
        }
        if (siret) {
          return this.entiteService.getEntites(siret).pipe(
            map((entites) => EntiteActions.getEntitesSuccess({ entites })),
            catchError(() =>
              of(
                EntiteActions.getEntitesFailure({
                  errorMessage: 'Erreur pendant la récuperation de la liste des entreprises',
                }),
              ),
            ),
          );
        }
        return of(
          EntiteActions.getEntitesFailure({
            errorMessage: "Vous n'êtes pas connecté.",
          }),
        );
      }),
    ),
  );


  constructor(
    private actions$: Actions,
    private entiteService: EntiteService,
    private store$: Store
  ) { }
}
